export default __webpack_public_path__ + "static/media/LogoConvocatoriaGeneric.31d515ed.PNG";